var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookDemoSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2335 22H30.9974C32.4842 22 33.4512 23.5646 32.7863 24.8944L29.2863 31.8944C28.9475 32.572 28.255 33 27.4974 33H23.4797C23.3162 33 23.1533 32.9799 22.9946 32.9403L19.2335 32M26.2335 22V17C26.2335 15.8954 25.3381 15 24.2335 15H24.138C23.6385 15 23.2335 15.405 23.2335 15.9045C23.2335 16.6188 23.0221 17.3172 22.6258 17.9115L19.2335 23V32M26.2335 22H24.2335M19.2335 32H17.2335C16.1289 32 15.2335 31.1046 15.2335 30V24C15.2335 22.8954 16.1289 22 17.2335 22H19.7335",
    stroke: "#4338CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDemoSuccessIcon);
export default __webpack_public_path__ + "static/media/bookDemoSuccessIcon.07a928b9c4b40175195b5fc92176a74e.svg";
export { ForwardRef as ReactComponent };